module.exports = "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard 3\n  </title>\n  <path d=\"M12.6 1H11v12c0 .829-.427 1.5-1.2 1.5-.773 0-1.4-.671-1.4-1.5v-.109h-.001C8.395 7.765 7.729 1 7.729 1H6.3s-.696 6.765-.7 11.891V13c0 .829-.627 1.5-1.4 1.5-.773 0-1.2-.671-1.2-1.5V1H1.4S.009 7.765.001 12.891H0V16c0 4.5 5 3 5 7.5V25h4v-1.5c0-4.5 5-3 5-7.5V12.891h-.001C13.991 7.765 12.6 1 12.6 1M26 0v25h-4v-4h-5c0-10 3.812-18.875 9-21\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-26-food-and-drink.svg
// module id = 3720
// module chunks = 168707334958949